import { render, staticRenderFns } from "./OrderFoodEntry.vue?vue&type=template&id=02ec496c&scoped=true"
import script from "./OrderFoodEntry.vue?vue&type=script&lang=js"
export * from "./OrderFoodEntry.vue?vue&type=script&lang=js"
import style0 from "./OrderFoodEntry.vue?vue&type=style&index=0&id=02ec496c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ec496c",
  null
  
)

export default component.exports